import { createStore } from 'effector'
import { $setNavigate } from './event'
import { NavigateFunction } from 'react-router-dom'

export const $navigate = createStore<NavigateFunction>(() => ({}))
  .on($setNavigate, (_, navigate) => navigate)
